import { getStore, removeStore, setStore } from "@/util/store";
import { foodmacMacruntimeWorkorderFindworkorderstatisticlist } from "@/api/hb-work-order/common";

const adsenseStore = {
    state: {
      // 当前编辑的类型
      currentEditAdsenseType:'',
      // 当前编辑的广告id
      currentEditAdsenseId:''
    },
    actions: {
       setCurrentEditAdsense({ commit }, data){
        // 存储当前type
        commit("SET_CURRENTEDITADSENSETYPE", data.type);
        // 存储当前id
        commit("SET_CURRENTEDITADSENSEID", data.id)
      }
    },
    mutations: {
      SET_CURRENTEDITADSENSETYPE:(state, currentEditAdsenseType) => {
        state.currentEditAdsenseType = currentEditAdsenseType
      },
      SET_CURRENTEDITADSENSEID(state, currentEditAdsenseId){
        state.currentEditAdsenseId = currentEditAdsenseId
      },
    }
  };
  export default adsenseStore